export default __webpack_public_path__ + "static/media/FormulaMeasurementList.60cd0af1.jpg";